import React, { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { setUIProperty } from '../actions';
import { compose, withState, withDispatch, withLifecycle } from '../enhancers';
import { getAuthUser, getUIProperty } from '../reducers';
import * as PrivateComponent from '../styles/PrivateSpacesPageStyled';
import DefaultLayout from '../components/layouts/DefaultLayout';
import useWindowSize from '../hooks/windowSize';
import { HorizontalItems, Text, VerticalItems } from '../styles/GenericStyled';
import Grid from '@material-ui/core/Grid';
import Link from '../components/generic/Link';
import blueMan from '../styles/images/blueMan.png';
import PSpaperMobile from '../components/privateSpaces/PSpaperMobile';
import PSpaper from '../components/privateSpaces/PSpaper';
import { BannerGradient, BannerImage, OverlayText } from '../styles/PrivateSpacesPageStyled';
import banner from '../styles/images/privateSpaces/virtualEvents.png';

const breakPoint = 1515;

const SectionTitle = ({ text }) => {
  const size = useWindowSize();

  return (
    <div style={{ marginBottom: size.width <= 1200 ? '0px' : '50px' }}>
      <Text
        type={size.width < 600 ? 'h6' : 'h4'}
        align="center"
        style={{ marginBottom: '5px' }}
        title="true"
      >
        {text}
      </Text>
      <hr style={{ margin: '0px' }} />
    </div>
  );
};

const VirtualEventsView = () => {
  useEffect(() => {
    document.title = `Booth Service`;
  }, []);

  const size = useWindowSize();

  const PaperContainers = [
    {
      text: 'E-commerce',
      description:
        'Boost your ROI and showcase your products in real-life dimensions and situations, while linking your e-shop.',
      source: blueMan,
      background: '#E7ECF7',
      id: '0',
    },
    {
      text: 'Trade Show',
      description:
        'Connect with potential customers and vendors in an interactive virtual expo event.',
      source: blueMan,
      background: '#E4DEE8',
      id: '1',
    },
    {
      text: 'Marketing',
      description:
        'Fully immerse your business in a striking virtual experience with advanced marketing capabilities.',
      source: blueMan,
      background: '#C7EBE4',
      id: '2',
    },
  ].map(obj =>
    size.width < 1200 ? (
      <PSpaperMobile
        id={obj.id}
        subtext={obj.subtext}
        text={obj.text}
        key={obj.text}
        description={obj.description}
        source={obj.source}
        background={obj.background}
      />
    ) : (
      <PSpaper
        id={obj.id}
        subtext={obj.subtext}
        text={obj.text}
        key={obj.text}
        description={obj.description}
        source={obj.source}
      />
    ),
  );

  return (
    <DefaultLayout>
      <div style={{ position: 'relative' }}>
        <BannerImage src={banner} />
        <BannerGradient />
        <OverlayText style={{ width: `${size.width < 600 ? '100%' : '80%'}` }}>
          <Text align="center" type={size.width < 600 ? 'h6' : 'h3'}>
            Virtual Events
          </Text>
          <Text
            style={{ display: '-webkit-inline-box' }}
            align="center"
            /*type={size.width < 600 ? 'sub2' : 'sub2'}*/
            type="sub2"
          >
            Are you looking into promoting and displaying your products and services online?
          </Text>

          <Text
            style={{ display: '-webkit-inline-box' }}
            align="center"
            /*type={size.width < 600 ? 'sub2' : 'sub2'}*/
            type="sub2"
          >
            Everything you need to showcase your business successfully with interactive pavilions to
            generate qualified leads
          </Text>
        </OverlayText>
      </div>

      <PrivateComponent.Section id="scroll-p" mobile={size.width < breakPoint}>
        {/*<SectionTitle text="Virtual Events" />*/}
        <VerticalItems>
          <HorizontalItems style={{ flexDirection: size.width < 1200 ? 'column' : 'row' }}>
            <Text type="sub2">
              Simulate the feeling of a real life event with rich visual surroundings
            </Text>
          </HorizontalItems>
          <HorizontalItems style={{ flexDirection: size.width < 1200 ? 'column' : 'row' }}>
            <Text type="sub2">
              Customizable exhibitor booths with personalized branding and design capabilities
            </Text>
          </HorizontalItems>
          <HorizontalItems style={{ flexDirection: size.width < 1200 ? 'column' : 'row' }}>
            <Text type="sub2">
              Interactive communication between exhibitors and customers who appear as avatars
            </Text>
          </HorizontalItems>
          <HorizontalItems style={{ flexDirection: size.width < 1200 ? 'column' : 'row' }}>
            <Text type="sub2">Event operations technical assistance</Text>
          </HorizontalItems>
        </VerticalItems>
      </PrivateComponent.Section>

      <PrivateComponent.Section mobile={size.width < 1200}>
        <SectionTitle text="Designed For" />
        <VerticalItems>
          <HorizontalItems style={{ flexDirection: size.width < 1200 ? 'column' : 'row' }}>
            {PaperContainers}
          </HorizontalItems>
        </VerticalItems>
      </PrivateComponent.Section>

      <PrivateComponent.Requestgrid
        container
        justify="space-evenly"
        alignItems="center"
        spacing={2}
      >
        <Grid item>
          <PrivateComponent.CustomTypography variant="h4" header="true">
            Interested in creating{' '}
            <PrivateComponent.CustomTypography variant="inherit" span="true">
              {size.width <= 666 && size.width >= 444 ? <br /> : <span />}
              your own virtual event?
            </PrivateComponent.CustomTypography>
          </PrivateComponent.CustomTypography>
        </Grid>
        <Grid item>
          <Link to="/contact">
            <PrivateComponent.CustomButton>
              Contact us
              <PrivateComponent.PlacedArrowIcon open={true} />
            </PrivateComponent.CustomButton>
          </Link>
        </Grid>
      </PrivateComponent.Requestgrid>
    </DefaultLayout>
  );
};

const lifecycleMap = {
  onDidMount: () => {
    ReactPixel.track('ViewContent');
  },
};

const mapState = state => ({
  currentUser: getAuthUser(state),
  requestOpen: getUIProperty('requestOpen'),
});
const mapDispatch = dispatch => ({
  setOpenRequest: status => dispatch(setUIProperty('requestOpen', status)),
});

const VirtualEvents = compose(
  withState(mapState),
  withDispatch(mapDispatch),
  withLifecycle(lifecycleMap),
)(VirtualEventsView);

export default VirtualEvents;
